<template>
<div class="notes">
  <div id="notes-body" class="notes-body">
    <template v-if="notes && notes.length">
      <div v-for="note in notes" v-bind:key="note.id" class="notes-content">
        <div class="notes-text">{{ note.message }}</div>
        <div class="notes-information">Por <strong>{{ note.author }}</strong> em {{ note.dateCreated | moment-date-hour }}</div>
      </div>
    </template>
    <template v-else>
      <div class="notes-content no-notes">Sem anotações</div>
    </template>
  </div>
  <div class="notes-footer">
    <label for="note">Anotação</label>
    <input v-model="message" type="text" placeholder="Digite sua anotação...">
    <button>
      <div v-if="loading" class="spinner-border spinner-border-sm send-message-loading" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <span v-else @click="sendMessage()">Salvar</span>
    </button>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      message: '',
      notes: null,
      load: false,
      noteEditingId: '',
      oldMessage: '',
      loading: false
    }
  },
  mounted () {
    if (this.$route.params.txid || this.id) {
      this.getNotes(true)
    }
    this.$root.$on('loadNotes', () => {
      this.getNotes(true)
    })
  },
  methods: {
    setOldValue (value) {
      if (this.oldMessage === '') {
        this.oldMessage = value
      }
    },
    setToEditing (note) {
      this.noteEditingId = note.id
      setTimeout(() => {
        document.getElementById(`note-edit-${note.id}`).focus()
      }, 1)
    },
    updateNote (note) {
      let noteToUpdate = this.notes.find(n => n.id === note.id)
      noteToUpdate.message = note.message

      if (document.getElementById(`note-edit-${note.id}`).value === '') {
        document.getElementById('oldValue').innerHTML = this.message
      }

      if (noteToUpdate.message.length > 1) {
        this.$http.put(`api/transactions/${note.id}`, {message: noteToUpdate.message})
          .then(function (res) {
            this.$bvToast.toast('Anotação atualizada com sucesso', {
              autoHideDelay: 5000,
              variant: 'success'
            })
          })
          .catch(function (res) {
            document.getElementById('oldValue').innerHTML = this.oldMessage
            console.error('Error')
            console.error(res)
            this.$bvToast.toast('Você não tem permissão para atualizar esta anotação', {
              autoHideDelay: 5000,
              variant: 'danger'
            })
          })
      }
      this.noteEditingId = ''
    },
    getNotes (showLast) {
      this.load = false
      if (this.$route.params.txid || this.id) {
        this.load = true
        this.$http.get(`api/transactions/${this.$route.params.txid ? this.$route.params.txid : this.id}/notes`)
          .then(function (res) {
            this.notes = res.data.list
          })
          .catch(function (res) {
            console.error('Error')
            console.error(res)
          })
      }
    },
    sendMessage () {
      this.$http.post(`api/transactions/${this.$route.params.txid ? this.$route.params.txid : this.id}/notes`, {message: this.message})
        .then(function (res) {
          console.error(res)
          this.message = ''
          this.getNotes(false)
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
        })
    }
  },
  watch: {
    '$route.params.txid' () {
      this.getNotes(true)
    },
    'id' () {
      this.getNotes(true)
    }
  },
  props: [
    'id'
  ]
}
</script>
<style lang="scss" scoped>
  .notes {
    .notes-body {
        height: 500px;
        max-height: 500px;
        width: 100%;
        overflow-y: scroll;
      .notes-content {
        padding: 16px;
        border-bottom: 1px solid #D2D2D2;
        .notes-text {
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;
          color: #666666;
        }
        .notes-information {
          font-size: 11px;
          font-weight: 400;
          line-height: 16px;
          color: rgba(0,0,0,0.50);
        }
        &.no-notes {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:last-child {
          border: none;
        }
      }
      &:first-child {
        padding-top: 32px;
      }
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.2);
        border-radius: 20px;
      }
    }
    .notes-footer {
      padding: 16px 16px 32px 16px;
      border-top: 1px solid #D2D2D2;
      label {
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        color: #666666;
      }
      input {
        width: 100%;
        height: 40px;
        padding: 8px 32px;
        margin-bottom: 16px;
        border: none;
        background-color: #F3F3F3;
        outline: none;
      }
      button {
        width: 100px;
        height: 32px;
        margin-bottom: 32px;
        border-radius: 5px;
        border: none;
        float: right;
        background-color: #1c56e0;
        color: #ffffff;

        .send-message-loading {
          color: #FFF;
          font-size: 5px;
        }
      }
    }
  }

  @media (max-height: 768px) {
    .notes-body {
      height: 291px !important;
      max-height: 291px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/NotesCustomer.vue